/**
 *
 * VoiceBrandPage
 *
 */
import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import EditComponentSection from './EditComponentSection';
import moment from 'moment';

// import styled from 'styles/styled-components';

import { FormattedMessage } from 'react-intl';

interface Props {}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    top: {
      padding: '20px',
      borderBottom: '1px solid #E3E3E4',
    },
    topHead: {
      fontFamily: 'Proxima-Nova-Regular',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '28px',
      lineHeight: '20px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    subtitleWrap: {
      height: '120px',
      borderRadius: '6px',
      backgroundColor: 'rgba(212,216,220,0.5)',
      alignItems: 'center',
      marginBottom: '12px',
    },
    topWrapper: {
      width: '100%',
      padding: '38px 20px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    subtitle: {
      width: '300px',
      paddingTop: '8px',
      fontFamily: 'Proxima-Nova-Regular',
    },
    subtitle1: {
      color: '#12161A',
      fontSize: '17px',
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: '24px',
    },
    body2: {
      color: '#000000',
      fontSize: '15px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '20px',
      fontFamily: 'ProximaNova-Medium',
    },
    buttonWrap: {
      display: 'flex',
    },
    typeWrap: {
      width: '240px',
      color: '#909599',
      fontFamily: 'Proxima-Nova-Regular',
      fontSize: '15px',
      fontWeight: 500,
      paddingTop: '9px',
      lineHeight: '20px',
      float: 'left',
    },
  }),
);

function HomePageSection(props) {
  const classes = useStyles();
  let {
    list: { activityTracker, activityUpdatedDate },
  } = props;

  return (
    <Grid className={classes.top}>
      <div className={classes.topHead}>HOME PAGE</div>
      <TraySection
        classes={classes}
        updatedAt={activityUpdatedDate}
        activityTracker={activityTracker}
        handleManage={() => {}}
      />
    </Grid>
  );
}
//function HandleManage();
function TraySection({
  classes,
  handleManage,
  updatedAt,
  activityTracker,
}: {
  classes: Record<
    | 'top'
    | 'topHead'
    | 'subtitleWrap'
    | 'topWrapper'
    | 'subtitle'
    | 'subtitle1'
    | 'body2'
    | 'buttonWrap'
    | 'typeWrap',
    string
  >;
  item: any;
  updatedAt: Date;
  activityTracker: any;
  handleManage();
}) {
  return (
    <Grid container className={classes.subtitleWrap}>
      <div className={classes.topWrapper}>
        <div className={classes.subtitle}>
          <div className={classes.subtitle1}>Activity Tracker Messaging</div>
        </div>
        <div className={classes.buttonWrap}>
          <div className={classes.typeWrap}>
            <div>Last Updated: {moment(updatedAt).format(`L`)}</div>
          </div>
          <EditComponentSection
            onClick={handleManage}
            title="ACTIVITY TRACKER MESSAGING"
            activityTrackerGoalMet={activityTracker.goalMetText}
            activityTrackerGoalExceeded={activityTracker.goalExceededText}
          />
        </div>
      </div>
    </Grid>
  );
}

export default HomePageSection;
